const carouselItems = [
  {
    title: '流浪地球3：终极远征',
    tag: '焦点专题',
    desc: '太阳系危机进入倒计时，人类命运共同体面临最终考验。地球发动机全功率启动，一场关乎文明存续的星际远征拉开帷幕。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20scene%20with%20massive%20space%20engines%20and%20glowing%20earth%2C%20dramatic%20orange%20and%20dark%20blue%20contrast%2C%20widescreen%20movie%20banner%20style%2C%20atmospheric%20and%20grand%20scale&width=1200&height=600&seq=carousel-focus-01&orientation=landscape',
  },
  {
    title: '封神宇宙：神话史诗',
    tag: '深度解读',
    desc: '从朝歌到西岐，从封神榜到山河社稷图，一部关于权力、信仰与人性的东方神话史诗正在展开。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20battle%20scene%20with%20warriors%20and%20palace%2C%20golden%20and%20crimson%20epic%20cinematic%20banner%2C%20dark%20dramatic%20sky%2C%20widescreen%20fantasy%20aesthetic&width=1200&height=600&seq=carousel-focus-02&orientation=landscape',
  },
  {
    title: '2026暑期档观影指南',
    tag: '观影指南',
    desc: '暑期档大片云集，从科幻到喜剧、从动画到悬疑，收下这份观影指南，不错过任何一部值得期待的佳作。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20marathon%20collage%20with%20film%20strips%20and%20popcorn%2C%20warm%20golden%20cinematic%20lighting%2C%20dark%20theater%20background%2C%20widescreen%20banner%20style%2C%20vibrant%20yet%20atmospheric&width=1200&height=600&seq=carousel-focus-03&orientation=landscape',
  },
  {
    title: '华语电影百年经典回顾',
    tag: '经典回顾',
    desc: '从默片时代到数字电影，华语电影走过百年历程。回顾那些定义时代的经典之作，感受光影艺术的不朽魅力。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20cinema%20scene%20with%20old%20film%20projector%20and%20classic%20movie%20posters%2C%20warm%20sepia%20and%20gold%20tones%2C%20nostalgic%20atmosphere%2C%20dark%20edges%2C%20widescreen%20banner&width=1200&height=600&seq=carousel-focus-04&orientation=landscape',
  },
  {
    title: '豆瓣高分TOP10深度解析',
    tag: '深度解析',
    desc: '豆瓣评分最高的十部电影，每一部都是影史经典。从叙事结构到视听语言，深度解读这些不朽佳作的艺术密码。',
    img: 'https://readdy.ai/api/search-image?query=Film%20critics%20review%20scene%20with%20movie%20screens%20and%20rating%20stars%2C%20warm%20cinematic%20lighting%2C%20dark%20theater%20atmosphere%2C%20elegant%20widescreen%20banner%20style&width=1200&height=600&seq=carousel-focus-05&orientation=landscape',
  },
  {
    title: '4K修复：让经典重获新生',
    tag: '技术专题',
    desc: '数字修复技术让老电影焕发新光彩。探索4K修复背后的技术奥秘，感受那些经过时间洗礼后依然动人的经典画面。',
    img: 'https://readdy.ai/api/search-image?query=Film%20restoration%20process%20with%20digital%20equipment%20and%20classic%20movie%20frames%2C%20warm%20amber%20and%20dark%20blue%20contrast%2C%20technical%20cinematic%20atmosphere%2C%20widescreen%20banner&width=1200&height=600&seq=carousel-focus-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">焦点专题</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">深度专题栏目，带你走进电影世界的每个角落</p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/40 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="relative w-full h-[180px] md:h-[220px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-lg bg-accent-500/85 text-background-50 text-[11px] font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-50 group-hover:text-primary-400 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-300 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}